import React from "react";
import { Link } from "react-router-dom";

const NotFound = ({ title, linkTitle, link, button }) => {
  const emtpyUrl = process.env.REACT_APP_URL + "/empty1.png";

  return (
    <div>
      <center>
        <img alt="" src={emtpyUrl} />
        <div>
          <h2>{title} not added yet.</h2>
          {button ? (
            <Link className="btn btn--primary" to={link}>
              Add New {linkTitle}
            </Link>
          ) : (
            ""
          )}
        </div>
      </center>
    </div>
  );
};

export default NotFound;
